import { useNavigate, useParams } from "react-router-dom"
import { UrlPath } from "../../../../config/routeConfig"
import { LoadingScreen } from "../../../UiComponents/LoadingComponent"
import { BreadCrumbs } from "../../../shared/breadCrumbs/BreadCrumbs"
import { TopBar } from "../../../shared/topBar/TopBar"
import { useDispatch, useSelector } from "react-redux"
import { useCallback, useRef, useState } from "react"
import { useEffect } from "react"
import { getAsset } from "../../../actions/assetAction"
import { SBAComboBox } from "../../../UiComponents/SBADropDown"
import { AgGridReact } from "ag-grid-react"
import { sbaAxios } from "../../../utils/sbaAxios"
import { InsertAnalystExposureData, getAnalystGridData, getAnalystGridSectHeader } from "../../../../config/apiConfig"
import { getAssestListddlAction } from "../../../actions/assetsddlAction"
import { useMemo } from "react"
import { SBNotify } from "../../../utils/sbNotify"
import { ToastContainer } from "react-toastify"
import moment from "moment";
import { SBDatePicker } from "../../../UiComponents/SBDatePicker";


const headerTemplateId = 2;

/* currently one state is only used for date picker
 * 
 * 
 * 
 * 
 * 
 * 
 * 
 */


function getPreviousMonthEndDate() {
    const currentDate = new Date();
    currentDate.setMonth(currentDate.getMonth() - 2);
    const lastDayOfMonth = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 0);
    return lastDayOfMonth.toISOString();
}
export const AnalystExposure = () => {
    //univresal consts used across the components
    const dispatch = useDispatch();
    const params = useParams();
    const history = useNavigate();
    const Gstate = useSelector((state) => state);
    const currentAsset = useSelector((state) => state.asset.asset);
    const AssetListDDL = useSelector(state => state.assetDDL.assetList);
    const Level = [{ BreadCrumb: "Asset >", Routes: `${UrlPath.Asset}` }, { BreadCrumb: `${currentAsset?.AssetName} >`, Routes: `${UrlPath.AssetDetails}${params.Asset}` }, { BreadCrumb: `Analyst Exposure`, Routes: `${UrlPath.AnalystExposure}${params.Asset}` }];
    //allstates here
    const [render, setRender] = useState(false);
    const [updateChild, setUpdateChild] = useState(false);
    const [selectedDate, setSelectedDate] = useState(getPreviousMonthEndDate());
    const [saveData, setSaveData] = useState([]);
    useEffect(() => {
        document.title = `Analyst Exposure`;
    }, []);

    //variable that are used across this component alone



    //sideEffects methods starts here


    //Initial useeffect
    useEffect(() => {
        currentAsset.AssetId !== parseInt(params.Asset) && dispatch(getAsset(params.Asset));
        AssetListDDL?.length < 1 && dispatch(getAssestListddlAction());
    }, [params.Asset]);

    //functions here



    const assetDropDownChange = (e) => {
        history(`${UrlPath.AnalystExposure}${e.value.AssetId}`);
    };

    const setStates = () => {
        setUpdateChild(value => !value);
    };
    const updateDate = (e) => {
        setSelectedDate(e.toISOString());
    };
    const saveAnalytGridData = () => {
        const formattedData = saveData.map(item => {
            let exposureValue;
        
            if (item.ExposureTypeId === 34) {
                exposureValue = item.ExposureValue;
            } else if (item.ExposureSectionId !== 4) {
                exposureValue = item.ExposureValue / 100;
            } else {
                exposureValue = item.ExposureValue;
            }
        
            return {
                ...item,
                ExposureValue: exposureValue
            };
        });
        
        sbaAxios({ url: InsertAnalystExposureData, method: 'post', data: formattedData }).then(response => {
            SBNotify({ Msg: "Analyst Data Updated Successfully", type: "success" })
        }).catch(error => {
            console.log(error, 'Error Updating Data ')
        });
        setSaveData([]);
    }
    return <>
        <TopBar label={"Analyst Exposure"} />
        <div id="analystExposure" className="mainContentData">
            <BreadCrumbs Levels={Level} />
            <>
                <div className="p-4" >
                    <div className="row gap-3">
                        <div className="col-md-3 col-lg-3 ">
                            <label className="label">Select Asset</label>
                            <SBAComboBox data={AssetListDDL} value={currentAsset} textField={"AssetName"} valueField={"AssetId"} onChange={(e) => { assetDropDownChange(e) }} />
                        </div>
                        <div className="col-md-3 col-lg-3 ">
                            <label className="label mb-0">Select Date</label>
                            <SBDatePicker className="w-100" value={moment(selectedDate)} onChange={(e) => { updateDate(e) }} />
                        </div>
                        <div className="col-md-3 col-lg-3 row-items d-flex gap-3">
                            <button className="p-sm-btn w-50" onClick={() => { setStates() }} >Enter</button>
                            <button className="p-sm-btn w-50" onClick={() => { saveAnalytGridData() }} >Save</button>
                        </div>
                    </div>
                    <SelectedAnlaystData AssetId={params.Asset} SelectedDate={selectedDate} updateChild={updateChild} setSaveData={setSaveData} saveData={saveData} />
                </div>
            </>
        </div>
        <ToastContainer />
    </>
}

const SelectedAnlaystData = (props) => {
    const { AssetId, SelectedDate, updateChild, setSaveData } = props;
    const [gridDef, setGridDef] = useState([]);
    const [rowData, setRowData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [apiData, setApiData] = useState([]);
    const gridRef = useRef();
    const params = useParams();

    const defaultDef = {
        flex: 1,
        minWidth: 150,
        wrapHeaderText: true,
        autoHeaderHeight: true,
        editable: true,
        cellDataType: false,
        singleClickEdit: true,
        resizable:true
    };
    useEffect(() => {
        getgridData().then(
            setTimeout(() => {
                setLoading(false)  
            }, 1000)
            );
    }, [updateChild,params]);
    function getFormattedGridDef(inputData) {
        const result = [];
        const sectionsMap = {};
        inputData.forEach((item, index) => {
            const sectionId = item.ExposureSectionId;
            const typeId = item.ExposureTypeId;

            if (!sectionsMap[sectionId]) {
                sectionsMap[sectionId] = {
                    headerName: item.ExposureSection,
                    field: `ExposureSectionId-${sectionId}`,
                    children: [],
                    
                    headerClass:"ag-grid-BR"
                };
                result.push(sectionsMap[sectionId]);
            };
            sectionsMap[sectionId].children.push({
                headerName: item.ExposureType,
                field: `ExposureTypeId-${typeId}`,
                cellRenderer: (params)=>{
                    if(typeId===34 || typeId==46
                        || typeId== 47 || 
                        typeId== 48){
                        return NumberRenderer(params);
                    }
                    else 
                    // if (sectionId !== 4)
                     {
                        return PercentageRenderer(params);
                    }
                    // else 
                    // return NumberRenderer(params);
                },
                editable: (params) => {
                    if(params.data.editable)
                    {
                        if(sectionId===1 && (typeId ===34 || typeId===3 || typeId===4)  )
                        {
                            return false;
                        }
                        else if(sectionId===6 || sectionId ===3 || typeId===14 )
                        {
                            return false;
                        }
                        else {
                            return true;
                        }
                    }
                    else
                    {
                    return params.data.editable
                    }
                },
                cellStyle: ({ value }) => ({ textAlign: 'right', color: (value < 0) ? 'red' : '' })
            });
           
        });
        result.map(item=>{
            const updatedChild=item.children.map((child,index)=>{
                if(index===item.children.length-1)
                {
                    return {...child,cellClass:"ag-grid-BR",headerClass:"ag-grid-BR"};
                }
                else {
                    return {...child};
                }
            })
            item.children=updatedChild;
        })
        return result;
    };
    function getFormattedRowData(unFormattedRowData) {
        const outPutData = [];
        function formatingMethid(target, item) {
            const exposureType = `ExposureTypeId-${item.ExposureTypeId}`;
        
            if (item.ExposureTypeId === 34 || item.ExposureTypeId === 46 || item.ExposureTypeId === 47 || item.ExposureTypeId === 48) {
                target[exposureType] = item.ExposureValue;
            } else if (item.ExposureTypeId === 2) {
                if (item.ExposureValue != null) {
                    target[exposureType] = item.ExposureValue < 0
                        ? item.ExposureValue * 100
                        : item.ExposureValue * -100;
                }
            } else if (item.ExposureTypeId === 3) {
                if (target["ExposureTypeId-1"] != null && target["ExposureTypeId-2"] != null) {
                    target[exposureType] = target["ExposureTypeId-1"] - target["ExposureTypeId-2"];
                } else {
                    target[exposureType] = item.ExposureValue;
                }
            } else if (item.ExposureTypeId === 4) {
                if (target["ExposureTypeId-1"] != null && target["ExposureTypeId-2"] != null) {
                    target[exposureType] = target["ExposureTypeId-1"] + target["ExposureTypeId-2"];
                } else {
                    target[exposureType] = item.ExposureValue;
                }
            } else {
                target[exposureType] = item.ExposureValue * 100;
            }
        }
        
        unFormattedRowData.forEach(item => {
            const existing = outPutData.find(data => data.ExposureId === item.ExposureId);
            if (existing) {
                formatingMethid(existing,item)
               
            } else {
                const newItem = {
                    "Name": item.ExposureName === item.RootName
                        ? [item.RootName]
                        : [item.RootName, item.ExposureName],
                    "ParentName": item.ExposureName !== item.RootName ? item.RootName : null,
                    "ExposureId": item.ExposureId,
                    "RootId": item.RootId,
                    "SortOrder": item.SortOrder,
                    "editable": item.ExposureName !== item.RootName,
                    "uniqueName": item.ExposureName === item.RootName ? item.RootName
                        : item.ExposureName,
                    "AssetExposureId": item.AssetExposureId,
                    "AssetId": item.AssetId,
                };
                //const exposureType = `ExposureTypeId-${item.ExposureTypeId}`;
                // newItem[exposureType] = item.ExposureValue * 100;
                // if(item.ExposureTypeId===34 || item.ExposureTypeId===46 || item.ExposureTypeId===47 || item.ExposureTypeId===48 ){
                //     item[exposureType] = item.ExposureValue 
                // }
                // else 
                // newItem[exposureType] = item.ExposureValue * 100;
                formatingMethid(newItem,item)
                outPutData.push(newItem);
            }
        });
        return outPutData;
    };
    const NumberRenderer=({value})=>{
        if (value === null) {
            return <span></span>;
        }
        return <span>{(parseFloat(value)).toFixed(2)}</span>;
    };
    const PercentageRenderer = ({ value }) => {
        if (value == null || value === 0 || Number.isNaN(value)) {
            return <span></span>;
        }        
        return <span>{(parseFloat(value)).toFixed(2)}%</span>;
    };
    const getgridData = async () => {
        await sbaAxios({ url: `${getAnalystGridSectHeader}${headerTemplateId}` }).then(res => {
            setGridDef([...getFormattedGridDef(res)]);
        }).catch(error => {
            console.log(error, 'error fetching analyst grid header');
        });
        await sbaAxios({ url: `${getAnalystGridData}${headerTemplateId}/${AssetId}/${SelectedDate}` }).then(response => {
            setRowData(getFormattedRowData(response));
            setApiData(response);
        }).catch(error => {
            console.log(error, 'error fetching analyst grid data');
        })
    };
    const getDataPath = useMemo(() => {
        return (data) => {
            return data.Name;
        };
    }, []);

    const ExpandCollapseButton = () => {
        const [expanded, setExpanded] = useState(true);
        const onExpandAll = () => {
            setExpanded(true);
            gridRef.current.api.expandAll();
        };
        const onCollapseAll = () => {
            setExpanded(false);
            gridRef.current.api.collapseAll();
        };
        return (
            <div className="expand-collapse-button"> {!expanded ?
                <button onClick={onExpandAll} className="p-sm-btn">Expand All</button>
                :
                <button onClick={onCollapseAll} className="p-sm-btn">Collapse All</button>
            }
            </div>
        );
    };
    const autoGroupColumnDef = useMemo(() => {
        return {
            headerName: 'Name',
            minWidth: 300,
            cellRendererParams: {
                suppressCount: true,
            },
            pinned: "left",
            headerComponent: ExpandCollapseButton,
            editable: false,
            headerClass:"ag-grid-BR"
        }
    }, []);
    const onCellValueChanged = (params) => {
        const { data, colDef, newValue } = params;
        const convertedValue=parseFloat(newValue) || 0;
        if(colDef.field==="ExposureTypeId-2")
        {
            data[colDef.field] =   convertedValue<0 ?convertedValue :convertedValue *-1;
        }
        else 
        {
            if(data["ExposureTypeId-2"]<0 || data["ExposureTypeId-2"]>0 || data["ExposureTypeId-2"]==0)
            {}
            else 
            {data["ExposureTypeId-2"]=0}
            data[colDef.field] = convertedValue;
        }
        data["ExposureTypeId-3"] = data["ExposureTypeId-1"] - data["ExposureTypeId-2"];
        data["ExposureTypeId-4"] = data["ExposureTypeId-1"] + data["ExposureTypeId-2"];
        data["ExposureTypeId-43"] = (data["ExposureTypeId-8"] / 100) * data["ExposureTypeId-1"];
        data["ExposureTypeId-44"] = (data["ExposureTypeId-11"] / 100) * data["ExposureTypeId-2"];
        data["ExposureTypeId-45"] = data["ExposureTypeId-43"] + data["ExposureTypeId-44"];
        data["ExposureTypeId-48"] = data["ExposureTypeId-46"] + data["ExposureTypeId-47"];
        data["ExposureTypeId-34"] = data["ExposureTypeId-2"]!==0 ? parseFloat(Math.abs(data["ExposureTypeId-1"] / data["ExposureTypeId-2"])) : 0;
        const parentRow = rowData.find(item => item.uniqueName === data.ParentName);
        const parentRowIndex = rowData.findIndex(item => item.uniqueName === data.ParentName);
        const childRow = rowData.filter(item => item.ParentName === data.ParentName);
        


        //calculation performed here for parent total
        const accumulatedValues = {};
        childRow.forEach((child) => {
            for (const key in child) {
                if (key.startsWith("ExposureTypeId-")) {
                    if (!accumulatedValues[key]) {
                        accumulatedValues[key] = null;
                    }
                    if (child[key] !== null) {
                        accumulatedValues[key] += child[key];
                    }
                }
            }
        });
        for (const key in accumulatedValues) {
            parentRow[key] = accumulatedValues[key];
        };
        const localRowData = [...rowData];
        localRowData[parentRowIndex] = parentRow;
        const ExposureTypeID = parseInt(colDef.field.split("-")[1]);
        const getSaveDataFields = apiData.filter(item => item.ExposureId === data.ExposureId).map(item=>{
                const key=`ExposureTypeId-${item.ExposureTypeId}`
                item.ExposureValue = data[key]
            return item;            
            }).filter(item=>item.ExposureValue!=null);
        // if (getSaveDataFields.length > 0) {
        //     if (colDef.field === "ExposureTypeId-2")
        //         getSaveDataFields[0].ExposureValue = convertedValue <= -1 ? convertedValue : convertedValue * -1;
        //     else
        //         getSaveDataFields[0].ExposureValue = convertedValue;
        // };
        setSaveData(value => [...value.filter(item=>item.ExposureId!=data.ExposureId), ...getSaveDataFields]);
        setRowData(localRowData);
    };
    return <>
        {loading ? <><LoadingScreen /></> :
            <div className="ag-theme-alpine" >
                <AgGridReact
                    columnDefs={gridDef}
                    ref={gridRef}
                    defaultColDef={defaultDef}
                    rowData={rowData}
                    getDataPath={getDataPath}
                    treeData={true}
                    autoGroupColumnDef={autoGroupColumnDef}
                    onCellValueChanged={onCellValueChanged}
                    rememberGroupStateWhenNewData={true}
                    groupDefaultExpanded={-1}
                />
            </div>}
    </>
};
